import React ,{ useState } from 'react';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import Config from 'app/Config';
import { ButtonType } from './constant';
import { buildUrlAndNavigate , navigateTo } from 'app/utilities/StringHelpers/StringHelpers';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import Image from 'app/Components/Shared/Image/image';
const ButtonElement = (props) => {
    var {type ,text ,description ,pageReferenceUrl ,displayButton ,textElementsPopup}= props.item;
    const desktopBackgroundUrl = Config.epiBaseUrl + props.item.desktopBackgroundUrl;
 
   type = isNullOrEmpty(type) ? ButtonType.PLUS : type;
 
const handleClick = () => {
    
 if (type === ButtonType.PLUS) {  
        props.setPopupData({...props.item.popupElement[0] , pageReferenceUrl , textElementsPopup});
    } else if (type === ButtonType.ARROW) {
        navigateTo(pageReferenceUrl);
    }
}

const getIcon = () => {

    switch (type) {
        case ButtonType.PLUS:
            return require("./icons/plus.svg");
        case ButtonType.ARROW:
            return require("./icons/left.svg");
        default:
            return null;
    }}


const DisplayButton = () => {
      if(!displayButton){
        return false;
    }
    switch (type) {
        case ButtonType.PLUS:
            return !(props.item.textElementsPopup.length == 0);
        case ButtonType.ARROW:
            return !isNullOrEmpty(pageReferenceUrl);
        default:
            return false;
    }
}

return (DisplayButton() && <Image src={getIcon()} className="button-element"  onClick={() => handleClick()}/>);
};

export default ButtonElement;
